import * as React from 'react';

import { Typography } from '@coursera/cds-core';

import Review from 'bundles/reviews-common/components/Review';
import type { ProductReview } from 'bundles/reviews-common/types/reviewsSharedTypes';
import { REVIEWS_PER_PAGE } from 'bundles/reviews/constants';

import _t from 'i18n!nls/reviews';

type Props = {
  currentPage: number;
  courseName: string;
  reviews?: Array<ProductReview>;
  totalReviews: number;
  userId?: number;
};

export function ReviewsList({ courseName, reviews, totalReviews, userId, currentPage }: Props) {
  if (!reviews || !reviews.length) {
    return null;
  }

  const numReviewsDisplayedStart = currentPage === 1 ? 1 : (currentPage - 1) * REVIEWS_PER_PAGE + 1;
  const numReviewsDisplayedEnd =
    numReviewsDisplayedStart + ((reviews.length < REVIEWS_PER_PAGE ? reviews.length : REVIEWS_PER_PAGE) - 1);

  return (
    <div className="rc-ReviewsList m-b-3" data-e2e="reviews-list">
      <Typography variant="d2" className="m-y-2 text-secondary">
        {_t('#{numReviewsDisplayedStart} - #{numReviewsDisplayedEnd} of #{totalReviews} Reviews for #{courseName}', {
          totalReviews: totalReviews > 0 ? totalReviews.toLocaleString() : 0,
          numReviewsDisplayedStart,
          numReviewsDisplayedEnd,
          courseName,
        })}
      </Typography>

      {reviews.map((review) => (
        // @ts-expect-error
        <Review review={review} key={review.id} userId={userId} />
      ))}
    </div>
  );
}

export default ReviewsList;
